import React, { useState } from 'react'
import Stylesheet from './MessageBox.module.css';
import Classnames from 'classnames';
import Button from '../../elements/Button/Button';
import Password from '../../elements/Password/Password';
import { AppContext } from '../../contexts/app';
import { ico_exclamation_triangle } from '../../icon';
import {user} from '@enigma/core/services';

function MessageBox(props) {
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState(null);
    let app = null;

    const onClose = (state) => {
        props.onReturn(state);
        props.onClose(props.title, props.content, props.type);
        setLoading(false);
    }

    const init = (appContext) => { app = appContext }

    const onReturn = (value) => {
        // check if user reauthentication was requested
        if (props.type === 'authenticate') {
            if (value !== 'cancled')  {
                if (!password || password === '') {
                    app.toggleToast(ico_exclamation_triangle, 
                    'password can not be empty', true);
                    return;
                }
                setLoading(true);
                // create credential
                const credential = user.emailAuthProviderCredential(
                user.email, password);
                // re-authenticate user
                user.current.reauthenticateWithCredential(credential)
                .then(_ => onClose(value))
                .catch(error => {
                    if (error.code === 'auth/wrong-password')
                        app.toggleToast(ico_exclamation_triangle, 
                        'your password was incorrect', true);
                    else 
                        app.toggleToast(ico_exclamation_triangle, 
                        'credentials could not be validated at this time', true);
                    setLoading(false);
                })
            } else onClose(value);
            
        } else onClose(value);
    }

    const getContent = () => {
        if (props.type === 'authenticate') {
            return (
                <div className={Stylesheet.Field}>
                    <h5>the operation requested is a security intensive task, for
                    security reasons please re-enter your current password.</h5>
                    <div className={Stylesheet.Input}>
                        <Password placeholder='enter current password'
                        icon onChange={value => setPassword(value)}/>
                    </div>
                </div>
            )
        } else return <p>{props.content}</p>;
    }

    const getControls = () => {
        if (props.type === 'yes_no') {
            return (
                <React.Fragment>
                    <div className={Stylesheet.Control}>
                        <Button secondary 
                        onClick={_ => onReturn('no')}>no</Button>
                    </div>
                    <div className={Stylesheet.Control}>
                        <Button primary 
                        onClick={_ => onReturn('yes')}>yes</Button>
                    </div>
                </React.Fragment>
            )
        } else if (props.type === 'ok_cancle') {

        } else if (props.type === 're-try') {

        } else if (props.type === 'approve_deny') {

        } else if (props.type === 'authenticate') {
            // render user re-authentication controls
            return (
                <React.Fragment>
                    <div className={Stylesheet.Control}>
                        <Button secondary disabled={loading}
                        onClick={_ => onReturn('cancled')}>
                        cancle</Button>
                    </div>
                    <div className={Stylesheet.Control}>
                        <Button primary loading={loading}
                        onClick={_ => onReturn('authenticated')}>
                        authenticate</Button>
                    </div>
                </React.Fragment>
            )
        }
        return null;
    }

    return (
        <AppContext.Consumer>
            {app => (
                <div className={Classnames(Stylesheet.Container, {
                [Stylesheet['show-container']]: props.show,
                [Stylesheet['hide-container']]: !props.show } )}>
                    {init(app)}
                    <div className={Classnames(Stylesheet.Overlay, {
                    [Stylesheet['show-overlay']]: props.show,
                    [Stylesheet['hide-overlay']]: !props.show })}></div>
                    <div className={Classnames(Stylesheet.MessageBox, {
                    [Stylesheet['show-messageBox']]: props.show,
                    [Stylesheet['hide-messageBox']]: !props.show})}>
                        <div className={Stylesheet.Header}>
                            <div className={Stylesheet.Title}>
                            <h5>{props?.title}</h5></div>
                        </div>
                        <div className={Stylesheet.Content}>
                            {getContent()}
                        </div>
                        <div className={Stylesheet.Controls}>
                            {getControls()}
                        </div>
                    </div>
                </div>
            )}
        </AppContext.Consumer>
    )
}

export default MessageBox;